import styled from 'styled-components'

export const SettingRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  width: 100%;
  padding: 0.25rem 0;

  @media (max-width: 480px) {
    align-items: flex-start;
  }
`

export const SettingInfo = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.875rem;
  min-width: 0;
  flex: 1;
`

export const SettingIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: ${({ theme }) =>
    theme.name === 'dark' ? theme.colors.background : theme.colors.borderSubtle};
  border: 1px solid ${({ theme }) => theme.colors.borderDefault};
  color: ${({ theme }) => theme.colors.action.primary.bg};
  font-size: 1.25rem;
`

export const SettingText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 0;
`

export const SettingTitle = styled.span`
  font-size: 0.9375rem;
  font-weight: 600;
  line-height: 1.3;
  color: ${({ theme }) => theme.colors.textPrimary};
`

export const SettingDescription = styled.span`
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.45;
  color: ${({ theme }) => theme.colors.textMuted};
`

export const SettingControl = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  padding-top: 0.25rem;
`
